/** Current app version — update manually with every release build. */
export const APP_VERSION = '10.0.0';

/**
 * Roles allowed to access admin-only tools (Debug Drafts, Update Answers).
 * Narrow to ['super_admin'] if these should be superadmin-only.
 */
export const ADMIN_ROLES = ['super_admin', 'admin'] as const;

/** Roles allowed to access the Create User (license) flow. */
export const CREATE_USER_ROLES = ['super_admin', 'admin', 'super_tech', 'supervisor'] as const;

export const IOS_STORE_URL = 'https://apps.apple.com/us/app/digimep-mobile/id1327672816';
export const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=iot.com.iot_android&hl=en&pli=1';
